import { render, staticRenderFns } from "./TeachingPaperModal.vue?vue&type=template&id=2660ceb7&scoped=true"
import script from "./TeachingPaperModal.vue?vue&type=script&lang=js"
export * from "./TeachingPaperModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2660ceb7",
  null
  
)

export default component.exports